import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedPosts } from "./relatedPostsAPI";

const initialState = {
  isLoading: false,
  relatedPosts: [],
  isError: false,
  error: null,
};

export const fetchRelatedPosts = createAsyncThunk(
  "relatedPosts/fetchRelatedPosts",
  async (postId) => {
    const relatedPosts = await getRelatedPosts(postId);
    return relatedPosts;
  }
);

export const relatedPostsSlice = createSlice({
  name: "relatedPosts",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedPosts.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchRelatedPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.relatedPosts = action.payload;
      })
      .addCase(fetchRelatedPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default relatedPostsSlice.reducer;
